const getEnv = (viteKey: string, craKey: string, fallback: string = "") => {
  if (typeof import.meta !== "undefined" && import.meta.env) {
    return import.meta.env[viteKey] || fallback;
  }
  return process.env[craKey] || fallback;
};

export const config = {
  apiHost: getEnv("VITE_API_HOST", "REACT_APP_API_HOST"),
  fileStorageUrl: getEnv("VITE_FILE_STORAGE_URL", "REACT_APP_FILE_STORAGE_URL"),
  projectName: getEnv("VITE_PROJECT_NAME", "PROJECT_NAME", "ggp-homepage"),
  port: getEnv("VITE_PORT", "PORT", "3072"),
  nodeEnv: import.meta?.env?.MODE || process.env.NODE_ENV || "development",
} as const;
